require('./dist/register');



//////////////////
// WEBPACK FOOTER
// ./~/@kadira/storybook-addon-knobs/register.js
// module id = 646
// module chunks = 0